export default __webpack_public_path__ + "static/media/cancel.de8908f6.svg";